import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CloseIcon from '@mui/icons-material/Close';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';

import BusinessTaxSubMenu from '@/components/nav/BusinessTaxSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';

const Form1120 = () => {
  const [open, setOpen] = useState(false);
  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Don't miss your payroll tax return deadline.`,
  //   SubHeading:
  //     'E-file Form 940 for easy compliance. File now and save time and stress.',
  //   CtaText: 'E-file Form 940 Now',
  //   CtaSubHeading: `Stay tax compliant with the IRS`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };
  const [closeSticky, setCloseSticky] = useState<boolean>(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  // const [progress, setProgress] = useState(0);
  const handleStickyClose = (): void => {
    setCloseSticky(true);
  };
  const images = [
    <img
      src="/assets/images/1120s-business-details-img.webp"
      key="first"
      alt="Corporation Details"
      id="loading1"
      className="details-images"
    />,
    <img
      src="/assets/images/1120s-income-img.webp"
      key="second"
      alt="Income and Expenses"
      className="details-images"
    />,
    <img
      src="/assets/images/1120s-shareholder-img.webp"
      key="third"
      alt="Shareholder Information"
      className="details-images"
    />,
    <img
      src="/assets/images/1120s-k-1allocation-img.webp"
      key="fourth"
      alt="K-1 Allocations"
      className="details-images"
    />,
    <img
      src="/assets/images/1120s-balance-sheet-img.webp"
      key="fifth"
      alt="Balance Sheet Details"
      className="details-images"
    />,
  ];
  const loader = ['loading1', 'loading2', 'loading3', 'loading4', 'loading5'];
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (currentIndex === images.length - 1) {
        setCurrentIndex(0);
      } else {
        setCurrentIndex(currentIndex + 1);
      }
    }, 10000);

    return () => clearInterval(intervalId);
  }, [currentIndex + 1]);
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (currentIndex === loader.length - 1) {
        setCurrentIndex(0);
      } else {
        setCurrentIndex(currentIndex + 1);
      }
    }, 10000);

    return () => clearInterval(intervalId);
  }, [currentIndex + 1]);
  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 9, 15));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 9, 15)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);

  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Days</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };
  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="File IRS Form 1120 Online for the 2025 Tax Year"
          description="E-file IRS Form 1120 for 2025 tax year. Prepare and file your C corporation's federal tax return with step-by-step guided filing and built-in validation"
          keywords=""
          canonical="business-tax/efile-irs-form-1120/"
          jsonLdPricing=""
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="1658"
          ogShareImg=""
        />
      }
    >
      <Hidden smDown>
        {!closeSticky && (
          <Box
            component="section"
            sx={{
              position: 'fixed',
              bottom: 0,
              width: '100%',
              left: 0,
              right: 0,
              zIndex: 3,
            }}
          >
            <Container
              maxWidth="md"
              sx={{
                backgroundColor: '#fff',
                mx: { xs: 3, lg: 'auto' },
                width: 'auto',
                py: 1.5,
                borderTopLeftRadius: 6,
                borderTopRightRadius: 6,
                boxShadow: '0 0 20px rgba(0,0,0,.5)',
                position: 'relative',
                borderWidth: 2,
                borderColor: '#414042',
                borderStyle: 'solid',
                borderBottom: 'none',
              }}
            >
              <Tooltip title="Close" arrow placement="top">
                <IconButton
                  aria-label="close"
                  size="small"
                  onClick={handleStickyClose}
                  sx={{
                    position: 'absolute',
                    right: -12,
                    top: -12,
                    color: '#fff',
                    backgroundColor: '#e11d1d',
                    '&:hover, &:focus': {
                      backgroundColor: '#b01919',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={{ xs: 1, sm: 1, md: 2 }}
                sx={{ justifyContent: 'space-between', alignItems: 'center' }}
              >
                <Box>
                  <Typography
                    component="div"
                    variant="body1"
                    sx={{
                      textAlign: { xs: 'center', sm: 'left' },
                      fontSize: { xs: 15, sm: 17, md: 18, lg: '1.25rem' },
                      //  color: '#ccc',
                      lineHeight: 1.3,
                    }}
                  >
                    <strong>Thank you</strong> for trusting{' '}
                    <b style={{ fontWeight: 600, color: '#213e99' }}>
                      TaxZerone
                    </b>{' '}
                    with your Form 1120 filing.
                  </Typography>
                </Box>
                {/* <Stack direction="row" alignItems="center" spacing={2}>
                  <Countdown date={lastDayTaxSeason} renderer={renderer} />
                  <Hidden mdUp>
                    <Box sx={{ textAlign: 'center' }}>
                      <Button
                        variant="contained"
                        size="medium"
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1120s`}
                        sx={{
                          textTransform: 'none',
                          px: 2.5,
                          display: 'inline-block',
                          boxShadow: 'none',
                          borderRadius: 4.2,
                          backgroundColor: '#213e99',
                          whiteSpace: 'nowrap',
                          '&:hover, &:focus': {
                            backgroundColor: '#172b6b',
                          },
                        }}
                      >
                        E-File Now
                      </Button>
                    </Box>
                  </Hidden>
                </Stack>
                <Hidden mdDown>
                  <Box sx={{ textAlign: 'center' }}>
                    <Button
                      variant="contained"
                      size="medium"
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1120s`}
                      sx={{
                        textTransform: 'none',
                        px: 2.5,
                        display: 'inline-block',
                        boxShadow: 'none',
                        borderRadius: 4.2,
                        backgroundColor: '#213e99',
                        whiteSpace: 'nowrap',
                        '&:hover, &:focus': {
                          backgroundColor: '#172b6b',
                        },
                      }}
                    >
                      E-File Now
                    </Button>
                  </Box>
                </Hidden> */}
              </Stack>
            </Container>
          </Box>
        )}
      </Hidden>
      <BusinessTaxSubMenu />
      {/* <ExitPopup1120S /> */}
      <ComingSoonPopup open={open} setOpen={setOpen} />
      {/* <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
        component="section"
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #a32cdf, #106ad2)',
            p: 1.5,
            px: 4,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              variant="body1"
              sx={{
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: 16, sm: 17, md: 20, lg: '1.24rem' },
                color: '#e0e0e0',
              }}
            >
              <strong>📢Attention S Corporations!</strong> E-file Your{' '}
              <span style={{ fontWeight: 600, color: '#eee' }}>
                {' '}
                2025 Form 1120
              </span>{' '}
              online and securely deliver Schedule K-1s to shareholders.
            </Typography>
            <Box sx={{}}> */}
      {/* <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time left to file before the deadline{' '}
                <Hidden smUp>
                  <br />
                </Hidden>
                (
                <span style={{ fontWeight: 600, color: '#fff' }}>
                  sept 15, 2026
                </span>
                ):
              </Typography> */}
      <Countdown date={lastDayTaxSeason} renderer={renderer} />
      {/* </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1120`}
                sx={{
                  backgroundColor: '#ee4266',
                  '&:hover, &:focus': {
                    backgroundColor: '#8338ec',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#fff',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: 18,
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-file Now!
              </Button>
              
            </Box>
          </Stack>
        </Box>
      </Container> */}

      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="header"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                File IRS{' '}
                <span className="highlight-container">
                  <span className="highlight">Form 1120</span>
                </span>{' '}
                Online for the 2025 Tax Year
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                <strong style={{ fontWeight: 600 }}>
                  E-file your C corporation's federal income tax return securely
                  with TaxZerone.
                </strong>{' '}
                Prepare and file Form 1120 online with guided filing, built-in
                validation, and a simple step-by-step process.
              </Typography>

              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    mr: { xs: 0, md: 4 },
                    mb: { xs: 2, sm: 0 },
                  }}
                >
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1120`}
                  >
                    E-File Form 1120
                  </Button>
                  {/* <Typography
                    variant="body2"
                    sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                  >
                    Takes 3 steps and less than 5 minutes
                  </Typography> */}
                </Box>

                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
              <Box
                sx={{
                  position: 'relative',
                  maxWidth: 580,
                  mx: { xs: 'auto', md: 0 },
                  mt: 5,
                }}
              />
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture
                style={{
                  marginBottom: 14,
                  marginTop: 14,
                  transform: 'rotate(1deg)',
                }}
              >
                <source
                  srcSet="/assets/images/banner-image-1120.svg"
                  className="img-responsive-banner"
                  width={621}
                  height={481}
                />
                <source
                  srcSet="/assets/images/banner-image-1120.svg"
                  className="img-responsive-banner"
                  width={621}
                  height={481}
                />
                <img
                  src="/assets/images/banner-image-1120.svg"
                  alt="File IRS Form 1120 Online for the 2025 Tax Year"
                  className="img-responsive-banner"
                  width={621}
                  height={481}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/banner-image-1120.svg"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/banner-image-1120.svg"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/banner-image-1120.svg"
                  alt="File IRS Form 1120 Online for the 2025 Tax Year "
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                File Form 1120 Online for Just{' '}
                <Box
                  component="strong"
                  sx={{
                    color: '#ffe400',
                    fontSize: { xs: 24, sm: 30 },
                  }}
                >
                  $199.99{' '}
                </Box>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 1,
                  textAlign: 'left',
                }}
              >
                <strong style={{ fontWeight: 600 }}>
                  {' '}
                  One flat fee. No hidden charges.{' '}
                </strong>{' '}
                Complete your{' '}
                <strong style={{ fontWeight: 600 }}>
                  Form 1120 tax return
                </strong>{' '}
                filing with TaxZerone and submit your corporation's federal
                income tax return electronically.
              </Typography>
            </Box>
            {/* <Typography variant="body1">Add-on services:</Typography>
              <Box component={'ul'} sx={{ mt: -0.1 }}>
                <li>
                  Postal K-1 Delivery:{' '}
                  <Box
                    component={'strong'}
                    sx={{
                      color: '#ffffffff',
                      fontSize: { xs: 24, sm: 24 },
                    }}
                  >
                    $1.75
                  </Box>{' '}
                  per recipient
                </li>
                <li>
                  {' '}
                  ZeroneVault Digital Delivery: Postal K-1 Delivery:{' '}
                  <Box
                    component={'strong'}
                    sx={{
                      color: '#fffad1ff',
                      fontSize: { xs: 24, sm: 24 },
                    }}
                  >
                    $0.50
                  </Box>{' '}
                  per recipient{' '}
                </li>
              </Box> */}

            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 250, md: 280 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              <Button
                size="large"
                variant="contained"
                href="/pricing/#businesstax"
                sx={{
                  boxShadow: 'none',
                  borderRadius: 2,
                  mb: 0.5,
                  textTransform: 'none',
                  backgroundColor: '#fff',
                  color: '#0a7581',
                  '&:hover, &:focus, &:active': {
                    color: '#fff',
                    backgroundColor: '#172b6b',
                  },
                }}
              >
                See Pricing
              </Button>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,

                    textAlign: 'left',
                  }}
                >
                  What is IRS Form 1120?
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }}>
                  <strong style={{ fontWeight: 600 }}>
                    IRS Form 1120, U.S. Corporation Income Tax Return
                  </strong>
                  , is the federal tax return used by{' '}
                  <strong style={{ fontWeight: 600 }}> C corporations </strong>{' '}
                  to report their{' '}
                  <strong style={{ fontWeight: 600 }}>
                    income, deductions, gains, losses, credits, and tax
                    liability to the IRS
                  </strong>
                  .
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                  Corporations use Form 1120 to calculate and report the federal
                  income tax they owe for the tax year.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/form-1120-img.webp" />
                  <source srcSet="/assets/images/form-1120-img.png" />
                  <img
                    src="/assets/images/form-1120-img.png"
                    alt="What is IRS Form 1120?"
                    className="img-responsive img-shadow"
                    loading="lazy"
                    width={450}
                    height={450}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Who Must File Form 1120?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                A{' '}
                <strong style={{ fontWeight: 600 }}>
                  domestic corporation
                </strong>{' '}
                generally must file Form 1120. Other entities and situations may
                also require{' '}
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>
                Form 1120 filing, including:
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container
          maxWidth="lg"
          sx={{
            px: { xs: 2, sm: 3, md: 4 },
            mb: 5,
          }}
        >
          {/* First 3 grids */}
          <Grid
            container
            alignItems="stretch"
            sx={{
              mx: 'auto',
            }}
          >
            {/* Grid 1 */}
            <Grid
              size={{ xs: 12, sm: 4 }}
              sx={{
                position: 'relative',
                px: { xs: 2, sm: 2.5, md: 3 },
                py: { xs: 3, sm: 3, md: 3.5 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                }}
              >
                <Box
                  sx={{
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/s-corporation-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/s-corporation-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/s-corporation-icon.png"
                      alt="Elected corporations"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: 1.3,
                  }}
                >
                  Elected corporations
                </Typography>

                <Typography variant="body1">
                  Eligible entities that elect to be taxed as corporations.
                </Typography>
              </Box>

              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  right: 0,
                  transform: 'translateY(-50%)',
                  width: '1px',
                  height: '88px',
                  backgroundColor: '#E5E7EB',
                  display: { xs: 'none', sm: 'block' },
                }}
              />
            </Grid>

            {/* Grid 2 */}
            <Grid
              size={{ xs: 12, sm: 4 }}
              sx={{
                position: 'relative',
                px: { xs: 2, sm: 2.5, md: 3 },
                py: { xs: 3, sm: 3, md: 3.5 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                }}
              >
                <Box
                  sx={{
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/corporations-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/corporations-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/corporations-icon.png"
                      alt="LLCs taxed as corporations"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: 1.3,
                  }}
                >
                  LLCs taxed as corporations
                </Typography>

                <Typography variant="body1">
                  An LLC electing C corporation treatment for federal tax.
                </Typography>
              </Box>

              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  right: 0,
                  transform: 'translateY(-50%)',
                  width: '1px',
                  height: '88px',
                  backgroundColor: '#E5E7EB',
                  display: { xs: 'none', sm: 'block' },
                }}
              />
            </Grid>

            {/* Grid 3 */}
            <Grid
              size={{ xs: 12, sm: 4 }}
              sx={{
                px: { xs: 2, sm: 2.5, md: 3 },
                py: { xs: 3, sm: 3, md: 3.5 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                }}
              >
                <Box
                  sx={{
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/farming-corporations-icon.webp"
                      width={60}
                      height={47}
                    />
                    <source
                      srcSet="/assets/images/farming-corporations-icon.png"
                      width={60}
                      height={47}
                    />
                    <img
                      src="/assets/images/farming-corporations-icon.png"
                      alt="Farming corporations"
                      loading="lazy"
                      width={60}
                      height={47}
                    />
                  </picture>
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: 1.3,
                  }}
                >
                  Farming corporations
                </Typography>

                <Typography variant="body1">
                  Corporations operating farming businesses.
                </Typography>
              </Box>
            </Grid>
          </Grid>

          {/* Horizontal divider */}
          <Box
            sx={{
              width: '100%',
              height: '1px',
              backgroundColor: '#E5E7EB',
            }}
          />

          {/* Next 3 grids */}
          <Grid
            container
            alignItems="stretch"
            sx={{
              mx: 'auto',
            }}
          >
            {/* Grid 4 */}
            <Grid
              size={{ xs: 12, sm: 4 }}
              sx={{
                position: 'relative',
                px: { xs: 2, sm: 2.5, md: 3 },
                py: { xs: 3, sm: 3, md: 3.5 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                }}
              >
                <Box
                  sx={{
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/mid-businesses-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/mid-businesses-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/mid-businesses-icon.png"
                      alt="Foreign-owned disregarded entities"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 1,
                    height: { xs: 'auto', sm: 48 },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: 1.3,
                  }}
                >
                  Foreign-owned disregarded entities
                </Typography>

                <Typography variant="body1">
                  Certain foreign-owned U.S. disregarded entities.
                </Typography>
              </Box>

              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  right: 0,
                  transform: 'translateY(-50%)',
                  width: '1px',
                  height: '88px',
                  backgroundColor: '#E5E7EB',
                  display: { xs: 'none', sm: 'block' },
                }}
              />
            </Grid>

            {/* Grid 5 */}
            <Grid
              size={{ xs: 12, sm: 4 }}
              sx={{
                position: 'relative',
                px: { xs: 2, sm: 2.5, md: 3 },
                py: { xs: 3, sm: 3, md: 3.5 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                }}
              >
                <Box
                  sx={{
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/unlimited-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/unlimited-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/unlimited-icon.png"
                      alt="Qualified opportunity funds"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: 1.3,
                  }}
                >
                  Qualified opportunity <br />
                  funds
                </Typography>

                <Typography variant="body1">
                  Funds organized as a corporation
                </Typography>
              </Box>

              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  right: 0,
                  transform: 'translateY(-50%)',
                  width: '1px',
                  height: '88px',
                  backgroundColor: '#E5E7EB',
                  display: { xs: 'none', sm: 'block' },
                }}
              />
            </Grid>

            {/* Grid 6 */}
            <Grid
              size={{ xs: 12, sm: 4 }}
              sx={{
                px: { xs: 2, sm: 2.5, md: 3 },
                py: { xs: 3, sm: 3, md: 3.5 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                }}
              >
                <Box
                  sx={{
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/secure-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/secure-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/secure-icon.png"
                      alt="FASIT interests"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  FASIT interests
                </Typography>

                <Typography variant="body1">
                  Entities with an ownership interest in a Financial Asset
                  Securitization Investment Trust
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'center',
                  md: 'center',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Form 1120 for LLC: Does an LLC File Form 1120?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Not generally. An LLC files Form 1120 only when it has elected
                  to be treated as a corporation for federal tax purposes.
                  <br />
                  Otherwise, its default classification leads to a different
                  return.
                </Typography>
                <Box component="div" sx={{ mt: 4 }}>
                  <TableContainer
                    sx={{
                      border: '1px solid #e5e7ef',
                      borderRadius: '18px',
                      overflow: 'hidden',
                    }}
                  >
                    <Table
                      sx={{
                        width: '100%',
                        borderCollapse: 'separate',
                        borderSpacing: 0,
                      }}
                      aria-label="Due Date Chart"
                    >
                      <TableHead>
                        <TableRow
                          sx={{
                            backgroundColor: '#f1f1f1',
                          }}
                        >
                          <TableCell
                            sx={{
                              width: '50%',
                              fontWeight: 700,
                              fontSize: '14px',
                              letterSpacing: '1px',
                              textTransform: 'uppercase',
                              padding: '14px 22px',
                              borderBottom: '1px solid #e5e7ef',
                            }}
                          >
                            Business structure
                          </TableCell>

                          <TableCell
                            sx={{
                              width: '50%',
                              fontWeight: 700,
                              fontSize: '14px',
                              letterSpacing: '1px',
                              textTransform: 'uppercase',
                              padding: '14px 22px',
                              borderBottom: '1px solid #e5e7ef',
                            }}
                          >
                            Typical federal return
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        <TableRow>
                          <TableCell
                            sx={{
                              padding: '14px 22px',
                              fontSize: '14px',
                              borderBottom: '1px solid #e5e7ef',
                            }}
                          >
                            C Corporation
                          </TableCell>

                          <TableCell
                            sx={{
                              padding: '14px 22px',
                              fontSize: '14px',
                              fontWeight: 600,
                              borderBottom: '1px solid #e5e7ef',
                            }}
                          >
                            Form 1120
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell
                            sx={{
                              padding: '14px 22px',
                              fontSize: '14px',
                              borderBottom: '1px solid #e5e7ef',
                            }}
                          >
                            S Corporation
                          </TableCell>

                          <TableCell
                            sx={{
                              padding: '14px 22px',
                              fontSize: '14px',
                              fontWeight: 600,
                              borderBottom: '1px solid #e5e7ef',
                            }}
                          >
                            <Link
                              href="/business-tax/efile-irs-form-1120-s/"
                              sx={{
                                color: '#0202ff',
                              }}
                            >
                              Form 1120-S
                            </Link>
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell
                            sx={{
                              padding: '14px 22px',
                              fontSize: '14px',
                              borderBottom: '1px solid #e5e7ef',
                            }}
                          >
                            Multi-member LLC taxed as partnership
                          </TableCell>

                          <TableCell
                            sx={{
                              padding: '14px 22px',
                              fontSize: '14px',
                              fontWeight: 600,
                              borderBottom: '1px solid #e5e7ef',
                            }}
                          >
                            <Link
                              href="/business-tax/efile-irs-form-1065-online/"
                              sx={{
                                color: '#0202ff',
                              }}
                            >
                              Form 1065
                            </Link>
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell
                            sx={{
                              padding: '18px 22px',
                              fontSize: '14px',
                              borderBottom: 'none',
                            }}
                          >
                            Single-member LLC disregarded for federal tax
                            purposes
                          </TableCell>

                          <TableCell
                            sx={{
                              padding: '18px 22px',
                              fontSize: '14px',
                              borderBottom: 'none',
                            }}
                          >
                            Generally reported on owner's return
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                When is the Form 1120 filing deadline for the 2025 tax year?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 5,
                  textAlign: 'center',
                }}
              >
                Original and extended deadlines based on your corporation's tax
                year.
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container
          maxWidth="lg"
          sx={{
            mb: { xs: 2, sm: 6, md: 8 },
          }}
        >
          <Grid
            container
            justifyContent="center"
            spacing={{ xs: 2, md: 3 }}
            sx={{ mb: { xs: 3, md: 5 } }}
          >
            {/* Original due date */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }} sx={{ display: 'flex' }}>
              <Box
                sx={{
                  p: '6px',
                  borderRadius: { xs: '24px', md: '28px' },
                  backgroundColor: 'rgba(255,255,255,0.45)',
                  height: '100%',
                  width: '100%',
                  borderTop: '5px solid #1da94a',
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    height: '100%',
                    backgroundColor: '#fff',
                    borderRadius: { xs: '20px', md: '24px' },
                    p: { xs: 2, md: 3 },
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1.5}
                    sx={{ minWidth: 0 }}
                  >
                    <Box
                      sx={{
                        width: { xs: 40, sm: 40, md: 50 },
                        height: { xs: 40, sm: 40, md: 50 },
                        borderRadius: '20%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        backgroundColor: '#f0f6fe',
                      }}
                    >
                      <CalendarTodayIcon
                        sx={{
                          color: '#1da94a',
                          fontSize: { xs: 28, md: 30 },
                        }}
                      />
                    </Box>

                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        textAlign: 'left',
                        m: 0,
                      }}
                    >
                      Original due date
                    </Typography>
                  </Stack>
                  <Typography
                    component="strong"
                    sx={{
                      display: 'block',
                      mt: 2,
                      fontWeight: 700,
                      fontSize: { xs: 24, md: 26 },
                    }}
                  >
                    April 15, 2026
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      mt: 0.75,
                      color: '#6B7280',
                      fontSize: { xs: 14, md: 16 },
                      lineHeight: 1.6,
                    }}
                  >
                    Calendar-year C corporation (year ends Dec 31, 2025)
                  </Typography>
                </Paper>
              </Box>
            </Grid>

            {/* File Form 7004 */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }} sx={{ display: 'flex' }}>
              <Box
                sx={{
                  p: '6px',
                  borderRadius: { xs: '24px', md: '28px' },
                  backgroundColor: 'rgba(220, 229, 255, 0.45)',
                  boxShadow: {
                    xs: '0 0 0 1px rgba(200,212,240,0.5), 0 4px 12px rgba(120,140,200,0.08)',
                    sm: '0 0 0 1px rgba(200,212,240,0.5), 0 4px 12px rgba(120,140,200,0.08)',
                    md: '0 0 0 1px rgba(200,212,240,0.6), 0 6px 18px rgba(120,140,200,0.12)',
                  },
                  transition: 'box-shadow 0.3s ease',
                  '&:hover': {
                    boxShadow:
                      '0 0 0 1px rgba(200,212,240,0.7), 0 12px 30px rgba(120,140,200,0.22)',
                  },
                  height: '100%',
                  width: '100%',
                  borderTop: '5px solid #213e99',
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    height: '100%',
                    backgroundColor: '#fff',
                    borderRadius: { xs: '20px', md: '24px' },
                    p: { xs: 2, md: 3 },
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1.5}
                    sx={{ minWidth: 0 }}
                  >
                    <Box
                      sx={{
                        width: { xs: 40, sm: 40, md: 50 },
                        height: { xs: 40, sm: 40, md: 50 },
                        borderRadius: '20%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        backgroundColor: '#f0f6fe',
                      }}
                    >
                      <DescriptionOutlinedIcon
                        sx={{
                          color: '#213e99',
                          fontSize: { xs: 28, md: 30 },
                        }}
                      />
                    </Box>

                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        textAlign: 'left',
                        m: 0,
                      }}
                    >
                      {' '}
                      <Link
                        href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                        sx={{ color: '#0202ff' }}
                      >
                        File Form 7004
                      </Link>{' '}
                    </Typography>
                  </Stack>

                  <Typography
                    component="strong"
                    sx={{
                      display: 'block',
                      mt: 2,
                      fontWeight: 700,
                      fontSize: { xs: 24, md: 26 },
                    }}
                  >
                    By original due date
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      mt: 0.75,
                      color: '#6B7280',
                      fontSize: { xs: 14, md: 16 },
                      lineHeight: 1.6,
                    }}
                  >
                    Extension request. Provides additional time to file.
                  </Typography>
                </Paper>
              </Box>
            </Grid>

            {/* Extended due date */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }} sx={{ display: 'flex' }}>
              <Box
                sx={{
                  p: '6px',
                  borderRadius: { xs: '24px', md: '28px' },
                  backgroundColor: 'rgba(255,255,255,0.45)',
                  height: '100%',
                  width: '100%',
                  borderTop: '5px solid #1da94a',
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    height: '100%',
                    backgroundColor: '#fff',
                    borderRadius: { xs: '20px', md: '24px' },
                    p: { xs: 2, md: 3 },
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1.5}
                    sx={{ minWidth: 0 }}
                  >
                    <Box
                      sx={{
                        width: { xs: 40, sm: 40, md: 50 },
                        height: { xs: 40, sm: 40, md: 50 },
                        borderRadius: '20%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        backgroundColor: '#f0f6fe',
                      }}
                    >
                      <EventAvailableIcon
                        sx={{
                          color: '#1da94a',
                          fontSize: { xs: 28, md: 30 },
                        }}
                      />
                    </Box>

                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        textAlign: 'left',
                        m: 0,
                      }}
                    >
                      Extended due date
                    </Typography>
                  </Stack>

                  <Typography
                    component="strong"
                    sx={{
                      display: 'block',
                      mt: 2,
                      fontWeight: 700,
                      fontSize: { xs: 24, md: 26 },
                    }}
                  >
                    October 15, 2026
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      mt: 0.75,
                      color: '#6B7280',
                      fontSize: { xs: 14, md: 16 },
                      lineHeight: 1.6,
                    }}
                  >
                    Calendar-year C corporation
                  </Typography>
                </Paper>
              </Box>
            </Grid>
          </Grid>
          <Box component="div" sx={{ mt: 2, mb: 4 }}>
            <TableContainer
              sx={{
                border: '1px solid #e5e7ef',
                borderRadius: '18px',
                overflowY: 'hidden',
                overflowX: 'auto',
              }}
            >
              <Table
                sx={{
                  width: '100%',
                  borderCollapse: 'separate',
                  borderSpacing: 0,
                }}
                aria-label="Due Date Chart"
              >
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: '#f1f1f1',
                    }}
                  >
                    <TableCell
                      sx={{
                        width: '33.33%',
                        fontWeight: 700,
                        fontSize: '14px',
                        letterSpacing: '1px',
                        textTransform: 'uppercase',
                        padding: '14px 22px',
                        borderBottom: '1px solid #e5e7ef',
                      }}
                    >
                      Fiscal-year C corporation
                    </TableCell>

                    <TableCell
                      sx={{
                        width: '33.33%',
                        fontWeight: 700,
                        fontSize: '14px',
                        letterSpacing: '1px',
                        textTransform: 'uppercase',
                        padding: '14px 22px',
                        borderBottom: '1px solid #e5e7ef',
                      }}
                    >
                      Original due date
                    </TableCell>

                    <TableCell
                      sx={{
                        width: '33.33%',
                        fontWeight: 700,
                        fontSize: '14px',
                        letterSpacing: '1px',
                        textTransform: 'uppercase',
                        padding: '14px 22px',
                        borderBottom: '1px solid #e5e7ef',
                      }}
                    >
                      Extended due date
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  <TableRow sx={{ backgroundColor: '#fff' }}>
                    <TableCell
                      sx={{
                        padding: '14px 22px',
                        fontSize: '14px',
                        borderBottom: '1px solid #e5e7ef',
                      }}
                    >
                      Year ends on a date other than June 30
                    </TableCell>

                    <TableCell
                      sx={{
                        padding: '14px 22px',
                        fontSize: '14px',
                        borderBottom: '1px solid #e5e7ef',
                      }}
                    >
                      15th day of the 4th month after year-end
                    </TableCell>

                    <TableCell
                      sx={{
                        padding: '14px 22px',
                        fontSize: '14px',
                        borderBottom: '1px solid #e5e7ef',
                      }}
                    >
                      6 months after original due date
                    </TableCell>
                  </TableRow>

                  <TableRow sx={{ backgroundColor: '#fff' }}>
                    <TableCell
                      sx={{
                        padding: '18px 22px',
                        fontSize: '14px',
                        borderBottom: 'none',
                      }}
                    >
                      Year ends June 30
                    </TableCell>

                    <TableCell
                      sx={{
                        padding: '18px 22px',
                        fontSize: '14px',
                        borderBottom: 'none',
                      }}
                    >
                      15th day of the 3rd month after year-end
                    </TableCell>

                    <TableCell
                      sx={{
                        padding: '18px 22px',
                        fontSize: '14px',
                        borderBottom: 'none',
                      }}
                    >
                      7 months after original due date
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Alert
            icon={false}
            severity="warning"
            sx={{
              mt: 0,
              mb: 3,
              backgroundColor: '#f6e6ea',
              borderLeft: '3px solid #9e0834',
              color: '#9e0834',
            }}
          >
            <b>Special June 30 rule:</b> If your fiscal year ends June 30, 2026,
            Form 1120 is due September 15, 2026. The extension is generally 7
            months, making the extended deadline April 15, 2027.
          </Alert>
          <Alert
            severity="warning"
            icon={false}
            sx={{ mb: 0, borderLeft: '3px solid rgb(102, 60, 0)' }}
          >
            <b>Note:</b> An extension gives you more time to file but does not
            extend the deadline to pay any tax due.
          </Alert>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="xl" sx={{ mb: 5, mt: 5 }}>
          <Grid size={12} textAlign="center">
            <Typography
              variant="h2"
              sx={{
                fontSize: {
                  xs: 20,
                  sm: 28,
                  md: 32,
                  lg: 38,
                },
                fontWeight: 600,
                mb: 1,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              What You'll Need to File Form 1120
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: {
                  xs: 16,
                  sm: 18,
                  md: 18,
                  lg: 20,
                  xl: 22,
                },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
                textAlign: 'center',
              }}
            >
              Gather these before you start.
            </Typography>
          </Grid>
          <Grid
            container
            spacing={2}
            maxWidth="lg"
            width="100%"
            sx={{
              mx: 'auto',
              justifyContent: 'center',
            }}
          >
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: '12px',
                  minHeight: '100%',
                  p: 2,
                  backgroundColor: '#f6f6fa',
                }}
              >
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 2,
                    }}
                  >
                    Corporation details
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: 14,
                      lineHeight: 1.45,
                      color: '#6B7280',
                      mb: 1.2,
                    }}
                  >
                    Legal name, EIN, address, incorporation information
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: '12px',
                  minHeight: '100%',
                  p: 2,
                  backgroundColor: '#f6f6fa',
                }}
              >
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 2,
                    }}
                  >
                    Income information
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: 14,
                      lineHeight: 1.45,
                      color: '#6B7280',
                      mb: 1.2,
                    }}
                  >
                    Gross receipts, sales, interest, dividends, other income
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: '12px',
                  minHeight: '100%',
                  p: 2,
                  backgroundColor: '#f6f6fa',
                }}
              >
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 2,
                    }}
                  >
                    Business expenses
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: 14,
                      lineHeight: 1.45,
                      color: '#6B7280',
                      mb: 1.2,
                    }}
                  >
                    Salaries, rent, depreciation, taxes, interest, other
                    deductions
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: '12px',
                  minHeight: '100%',
                  p: 2,
                  backgroundColor: '#f6f6fa',
                }}
              >
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 2,
                    }}
                  >
                    Asset information
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: 14,
                      lineHeight: 1.45,
                      color: '#6B7280',
                      mb: 1.2,
                    }}
                  >
                    Property, equipment, depreciation, other business assets
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: '12px',
                  minHeight: '100%',
                  p: 2,
                  backgroundColor: '#f6f6fa',
                }}
              >
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 2,
                    }}
                  >
                    Liabilities
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: 14,
                      lineHeight: 1.45,
                      color: '#6B7280',
                      mb: 1.2,
                    }}
                  >
                    Loans, accounts payable, other obligations
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: '12px',
                  minHeight: '100%',
                  p: 2,
                  backgroundColor: '#f6f6fa',
                }}
              >
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 2,
                    }}
                  >
                    Shareholder information
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: 14,
                      lineHeight: 1.45,
                      color: '#6B7280',
                      mb: 1.2,
                    }}
                  >
                    Ownership and stock information where applicable
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: '12px',
                  minHeight: '100%',
                  p: 2,
                  backgroundColor: '#f6f6fa',
                }}
              >
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 2,
                    }}
                  >
                    Prior year return
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: 14,
                      lineHeight: 1.45,
                      color: '#6B7280',
                      mb: 1.2,
                    }}
                  >
                    Previous Form 1120 and supporting schedules
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: '12px',
                  minHeight: '100%',
                  p: 2,
                  backgroundColor: '#f6f6fa',
                }}
              >
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 2,
                    }}
                  >
                    Supporting forms
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: 14,
                      lineHeight: 1.45,
                      color: '#6B7280',
                      mb: 1.2,
                    }}
                  >
                    Applicable schedules and additional IRS forms
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How to File Form 1120 with TaxZerone?{' '}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Three simple steps from start to e-file.
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Box sx={{ position: 'relative' }}>
            {/* Main Connecting Line */}
            <Box
              sx={{
                display: { xs: 'none', md: 'block' },
                position: 'absolute',
                top: 37,
                left: '16%',
                right: '16%',
                height: 3,
                bgcolor: '#D9EEDC',
                zIndex: 0,
              }}
            />

            <Grid container spacing={4}>
              {/* STEP 1 */}
              <Grid size={{ xs: 12, md: 4 }}>
                <Box
                  sx={{
                    textAlign: 'center',
                    position: 'relative',
                    zIndex: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 70,
                      height: 70,
                      mx: 'auto',
                      borderRadius: '50%',
                      bgcolor: '#fff',
                      border: `3px solid var(--bs-secondary)`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative',
                      mb: 3,
                    }}
                  >
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        color: 'var(--bs-secondary)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 28,
                        fontWeight: 700,
                      }}
                    >
                      1
                    </Box>
                  </Box>

                  <Typography
                    component="h3"
                    sx={{
                      fontSize: 20,
                      fontWeight: 600,
                      mb: 1.5,
                    }}
                  >
                    Enter Your Corporation Details
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      color: '#666',
                      lineHeight: 1.8,
                      maxWidth: 320,
                      mx: 'auto',
                    }}
                  >
                    Select{' '}
                    <strong style={{ fontWeight: 600 }}>Form 1120</strong> and
                    provide your corporation's basic details, including its
                    legal name, EIN, address, and tax year.
                  </Typography>
                </Box>
              </Grid>

              {/* STEP 2 */}
              <Grid size={{ xs: 12, md: 4 }}>
                <Box
                  sx={{
                    textAlign: 'center',
                    position: 'relative',
                    zIndex: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 70,
                      height: 70,
                      mx: 'auto',
                      borderRadius: '50%',
                      bgcolor: '#fff',
                      border: `3px solid var(--bs-secondary)`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative',
                      mb: 3,
                    }}
                  >
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        color: 'var(--bs-secondary)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 28,
                        fontWeight: 700,
                      }}
                    >
                      2
                    </Box>
                  </Box>

                  <Typography
                    component="h3"
                    sx={{
                      fontSize: 20,
                      fontWeight: 600,
                      mb: 1.5,
                    }}
                  >
                    Enter Income & Tax Information
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      color: '#666',
                      lineHeight: 1.8,
                      maxWidth: 320,
                      mx: 'auto',
                    }}
                  >
                    Enter your corporation’s{' '}
                    <strong style={{ fontWeight: 600 }}>
                      income, deductions, credits, assets, liabilities,
                      dividends, and other applicable tax information
                    </strong>
                    .{' '}
                  </Typography>
                </Box>
              </Grid>

              {/* STEP 3 */}
              <Grid size={{ xs: 12, md: 4 }}>
                <Box
                  sx={{
                    textAlign: 'center',
                    position: 'relative',
                    zIndex: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 70,
                      height: 70,
                      mx: 'auto',
                      borderRadius: '50%',
                      bgcolor: '#fff',
                      border: `3px solid var(--bs-secondary)`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative',
                      mb: 3,
                    }}
                  >
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        color: 'var(--bs-secondary)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 28,
                        fontWeight: 700,
                      }}
                    >
                      3
                    </Box>
                  </Box>

                  <Typography
                    component="h3"
                    sx={{
                      fontSize: 20,
                      fontWeight: 600,
                      mb: 1.5,
                    }}
                  >
                    Review & E-file
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      color: '#666',
                      lineHeight: 1.8,
                      maxWidth: 320,
                      mx: 'auto',
                    }}
                  >
                    Review your completed Form 1120, verify the information, and
                    E-file your return
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
            <Button
              variant="contained"
              sx={{
                mt: 4,
                transition: 'all 0.3s ease 0s',
                '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
              }}
              className="btn-primary"
              href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1120`}
            >
              E-File Form 1120
            </Button>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why Choose TaxZerone for Form 1120?
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            m={2}
            mt={4}
            pb={{ xs: 0, sm: 4, md: 7 }}
            sx={{ justifyContent: 'center', p: 0, listStyleType: 'none' }}
            component="ul"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="IRS-Authorized E-file Provider"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS-Authorized E-file Provider
                </Typography>
                <Typography variant="body1">
                  File your{' '}
                  <strong style={{ fontWeight: 600 }}>IRS tax Form 1120</strong>{' '}
                  electronically through an IRS-authorized e-file provider.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="Guided Step-by-Step Workflow"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Guided Step-by-Step Workflow
                </Typography>
                <Typography variant="body1">
                  Follow a step-by-step process designed to simplify the{' '}
                  <strong style={{ fontWeight: 600 }}>
                    Form 1120 tax return
                  </strong>
                  .{' '}
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/error-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/error-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/error-icon.png"
                      alt="Built-in Error Checks"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Built-in Error Checks
                </Typography>
                <Typography variant="body1">
                  TaxZerone checks for common errors and missing information
                  before submission.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12} component="li">
                &nbsp;
              </Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/tax-calc-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/tax-calc-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/tax-calc-icon.png"
                      alt="Smart Calculations"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Smart Calculations
                </Typography>
                <Typography variant="body1">
                  {' '}
                  <strong style={{ fontWeight: 600 }}>
                    Automatically calculate
                  </strong>{' '}
                  your tax amounts as you enter your business information,
                  reduce errors and making corporate tax filing faster and
                  easier.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Transparent Pricing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Transparent Pricing
                </Typography>
                <Typography variant="body1">
                  File <strong style={{ fontWeight: 600 }}> Form 1120 </strong>{' '}
                  for a straightforward flat fee without unnecessary complexity.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Expert Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Expert Support
                </Typography>
                <Typography variant="body1">
                  Get real help from real people, expert assistance is always
                  available when you need guidance, in both{' '}
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    English and Spanish
                  </strong>
                  .{' '}
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5, mt: 5 }}>
          <Grid size={12} textAlign="center">
            <Typography
              variant="h2"
              sx={{
                fontSize: {
                  xs: 20,
                  sm: 28,
                  md: 32,
                  lg: 38,
                },
                fontWeight: 600,
                mb: 1,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              Key Schedules and Forms Related to Form 1120
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 2,
                textAlign: 'center',
              }}
            >
              Your <strong style={{ fontWeight: 600 }}>return</strong> may
              require additional schedules and forms depending on the
              corporation's activities and tax situation.{' '}
            </Typography>
            <Typography
              variant="h4"
              sx={{
                fontSize: { md: 18, sm: 17, xs: 16 },
                fontWeight: 600,
                mb: 6,
                lineHeight: 1.4,
              }}
            >
              Common schedules associated with Form 1120 include:{' '}
            </Typography>
          </Grid>
          <Container maxWidth="lg">
            <Grid container spacing={{ xs: 3, md: 3 }} alignItems="stretch">
              {/* Schedule C*/}
              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <Box
                  sx={{
                    position: 'relative',
                    boxSizing: 'border-box',
                    height: '100%',
                    minHeight: 208,
                    p: 2.5,
                    border: '2px solid #9b9b9b',
                    borderRadius: '20px',
                  }}
                >
                  {/* mask: cuts the dark border under the coloured line */}
                  <Box
                    sx={{
                      position: 'absolute',
                      boxSizing: 'border-box',
                      left: '-3px',
                      bottom: '-3px',
                      width: 'calc(39% + 16px)',
                      height: 'calc(48% + 16px)',
                      borderLeft: '4px solid #f0f2f9',
                      borderBottom: '4px solid #f0f2f9',
                      borderBottomLeftRadius: '21px',
                    }}
                  />
                  {/* coloured line */}
                  <Box
                    sx={{
                      position: 'absolute',
                      boxSizing: 'border-box',
                      left: '-3px',
                      bottom: '-3px',
                      width: '39%',
                      height: '48%',
                      borderLeft: '5px solid var(--bs-primary)',
                      borderBottom: '5px solid var(--bs-primary)',
                      borderBottomLeftRadius: '21px',
                    }}
                  />
                  {/* dots */}
                  <Box
                    sx={{
                      position: 'absolute',
                      left: '-6px',
                      top: 'calc(52% - 21px)',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: '#9b9b9b',
                      zIndex: 1,
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: '-6px',
                      left: 'calc(39% + 11px)',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: '#9b9b9b',
                      zIndex: 1,
                    }}
                  />
                  <Paper
                    elevation={0}
                    sx={{
                      position: 'relative',
                      height: '100%',
                      boxSizing: 'border-box',
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      px: { xs: 2 },
                      py: 4,
                      textAlign: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 24, md: 20, sm: 20, xs: 20 },
                        fontWeight: 600,
                        my: 1,
                      }}
                    >
                      Schedule C
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { xs: 13, md: 14 },
                        lineHeight: 1.6,
                      }}
                    >
                      Dividends, Inclusions, and Special Deductions
                    </Typography>
                  </Paper>
                </Box>
              </Grid>

              {/* Schedule D */}
              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <Box
                  sx={{
                    position: 'relative',
                    boxSizing: 'border-box',
                    height: '100%',
                    minHeight: 208,
                    p: 2.5,
                    border: '2px solid #9b9b9b',
                    borderRadius: '20px',
                  }}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      boxSizing: 'border-box',
                      left: '-3px',
                      top: '-3px',
                      width: 'calc(38% + 16px)',
                      height: 'calc(50% + 16px)',
                      borderLeft: '4px solid #f0f2f9',
                      borderTop: '4px solid #f0f2f9',
                      borderTopLeftRadius: '21px',
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      boxSizing: 'border-box',
                      left: '-3px',
                      top: '-3px',
                      width: '38%',
                      height: '50%',
                      borderLeft: '4px solid var(--bs-secondary)',
                      borderTop: '4px solid var(--bs-secondary)',
                      borderTopLeftRadius: '21px',
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '-6px',
                      left: 'calc(38% + 11px)',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: '#9b9b9b',
                      zIndex: 1,
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      left: '-6px',
                      top: 'calc(50% + 11px)',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: '#9b9b9b',
                      zIndex: 1,
                    }}
                  />
                  <Paper
                    elevation={0}
                    sx={{
                      position: 'relative',
                      height: '100%',
                      boxSizing: 'border-box',
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      px: { xs: 2 },
                      py: 4,
                      textAlign: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 24, md: 20, sm: 20, xs: 20 },
                        fontWeight: 600,
                        my: 1,
                      }}
                    >
                      Schedule D
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { xs: 13, md: 14 },
                        lineHeight: 1.6,
                      }}
                    >
                      Capital Gains and Losses
                    </Typography>
                  </Paper>
                </Box>
              </Grid>

              {/* Schedule J */}
              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <Box
                  sx={{
                    position: 'relative',
                    boxSizing: 'border-box',
                    height: '100%',
                    minHeight: 208,
                    p: 2.5,
                    border: '2px solid #9b9b9b',
                    borderRadius: '20px',
                  }}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      boxSizing: 'border-box',
                      right: '-3px',
                      top: '-3px',
                      width: 'calc(40% + 18px)',
                      height: 'calc(47% + 18px)',
                      borderRight: '4px solid #f0f2f9',
                      borderTop: '4px solid #f0f2f9',
                      borderTopRightRadius: '21px',
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      boxSizing: 'border-box',
                      right: '-3px',
                      top: '-3px',
                      width: '40%',
                      height: '47%',
                      borderRight: '4px solid var(--bs-primary)',
                      borderTop: '4px solid var(--bs-primary)',
                      borderTopRightRadius: '21px',
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '-6px',
                      right: 'calc(40% + 13px)',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: '#9b9b9b',
                      zIndex: 1,
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      right: '-6px',
                      top: 'calc(47% + 13px)',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: '#9b9b9b',
                      zIndex: 1,
                    }}
                  />
                  <Paper
                    elevation={0}
                    sx={{
                      position: 'relative',
                      height: '100%',
                      boxSizing: 'border-box',
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      px: { xs: 2 },
                      py: 4,
                      textAlign: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 24, md: 20, sm: 20, xs: 20 },
                        fontWeight: 600,
                        my: 1,
                      }}
                    >
                      Schedule J
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { xs: 13, md: 14 },
                        lineHeight: 1.6,
                      }}
                    >
                      Tax Computation and Payment
                    </Typography>
                  </Paper>
                </Box>
              </Grid>

              {/* Schedule K*/}
              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <Box
                  sx={{
                    position: 'relative',
                    boxSizing: 'border-box',
                    height: '100%',
                    minHeight: 208,
                    p: 2.5,
                    border: '2px solid #9b9b9b',
                    borderRadius: '20px',
                  }}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      boxSizing: 'border-box',
                      right: '-3px',
                      bottom: '-3px',
                      width: 'calc(37% + 18px)',
                      height: 'calc(51% + 18px)',
                      borderRight: '4px solid #f0f2f9',
                      borderBottom: '4px solid #f0f2f9',
                      borderBottomRightRadius: '21px',
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      boxSizing: 'border-box',
                      right: '-3px',
                      bottom: '-3px',
                      width: '37%',
                      height: '51%',
                      borderRight: '4px solid var(--bs-secondary)',
                      borderBottom: '4px solid var(--bs-secondary)',
                      borderBottomRightRadius: '21px',
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      right: '-6px',
                      top: 'calc(49% - 23px)',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: '#9b9b9b',
                      zIndex: 1,
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: '-6px',
                      right: 'calc(37% + 13px)',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: '#9b9b9b',
                      zIndex: 1,
                    }}
                  />
                  <Paper
                    elevation={0}
                    sx={{
                      position: 'relative',
                      height: '100%',
                      boxSizing: 'border-box',
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      px: { xs: 2 },
                      py: 4,
                      textAlign: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 24, md: 20, sm: 20, xs: 20 },
                        fontWeight: 600,
                        my: 1,
                      }}
                    >
                      Schedule K
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { xs: 13, md: 14 },
                        lineHeight: 1.6,
                      }}
                    >
                      Other Information
                    </Typography>
                  </Paper>
                </Box>
              </Grid>
              {/* Schedule L */}
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  sx={{
                    position: 'relative',
                    boxSizing: 'border-box',
                    height: '100%',
                    minHeight: 208,
                    p: 2.5,
                    border: '2px solid #9b9b9b',
                    borderRadius: '20px',
                  }}
                >
                  {/* mask: cuts the dark border under the coloured line */}
                  <Box
                    sx={{
                      position: 'absolute',
                      boxSizing: 'border-box',
                      left: '-3px',
                      bottom: '-3px',
                      width: 'calc(39% + 16px)',
                      height: 'calc(48% + 16px)',
                      borderLeft: '4px solid #f0f2f9',
                      borderBottom: '4px solid #f0f2f9',
                      borderBottomLeftRadius: '21px',
                    }}
                  />
                  {/* coloured line */}
                  <Box
                    sx={{
                      position: 'absolute',
                      boxSizing: 'border-box',
                      left: '-3px',
                      bottom: '-3px',
                      width: '39%',
                      height: '48%',
                      borderLeft: '5px solid var(--bs-primary)',
                      borderBottom: '5px solid var(--bs-primary)',
                      borderBottomLeftRadius: '21px',
                    }}
                  />
                  {/* dots */}
                  <Box
                    sx={{
                      position: 'absolute',
                      left: '-6px',
                      top: 'calc(52% - 21px)',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: '#9b9b9b',
                      zIndex: 1,
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: '-6px',
                      left: 'calc(39% + 11px)',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: '#9b9b9b',
                      zIndex: 1,
                    }}
                  />
                  <Paper
                    elevation={0}
                    sx={{
                      position: 'relative',
                      height: '100%',
                      boxSizing: 'border-box',
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      px: { xs: 2 },
                      py: 4,
                      textAlign: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 24, md: 20, sm: 20, xs: 20 },
                        fontWeight: 600,
                        my: 1,
                      }}
                    >
                      Schedule L
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { xs: 13, md: 14 },
                        lineHeight: 1.6,
                      }}
                    >
                      Balance Sheets per Books
                    </Typography>
                  </Paper>
                </Box>
              </Grid>
              {/* Schedule M-1 */}
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  sx={{
                    position: 'relative',
                    boxSizing: 'border-box',
                    height: '100%',
                    minHeight: 208,
                    p: 2.5,
                    border: '2px solid #9b9b9b',
                    borderRadius: '20px',
                  }}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      boxSizing: 'border-box',
                      left: '-3px',
                      top: '-3px',
                      width: 'calc(38% + 16px)',
                      height: 'calc(50% + 16px)',
                      borderLeft: '4px solid #f0f2f9',
                      borderTop: '4px solid #f0f2f9',
                      borderTopLeftRadius: '21px',
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      boxSizing: 'border-box',
                      left: '-3px',
                      top: '-3px',
                      width: '38%',
                      height: '50%',
                      borderLeft: '4px solid var(--bs-secondary)',
                      borderTop: '4px solid var(--bs-secondary)',
                      borderTopLeftRadius: '21px',
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '-6px',
                      left: 'calc(38% + 11px)',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: '#9b9b9b',
                      zIndex: 1,
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      left: '-6px',
                      top: 'calc(50% + 11px)',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: '#9b9b9b',
                      zIndex: 1,
                    }}
                  />
                  <Paper
                    elevation={0}
                    sx={{
                      position: 'relative',
                      height: '100%',
                      boxSizing: 'border-box',
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      px: { xs: 2 },
                      py: 4,
                      textAlign: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 24, md: 20, sm: 20, xs: 20 },
                        fontWeight: 600,
                        my: 1,
                      }}
                    >
                      Schedule M-1
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { xs: 13, md: 14 },
                        lineHeight: 1.6,
                      }}
                    >
                      Reconciliation of Income per Books with Income per Return
                    </Typography>
                  </Paper>
                </Box>
              </Grid>
              {/* Schedule m-2 */}
              <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                <Box
                  sx={{
                    position: 'relative',
                    boxSizing: 'border-box',
                    height: '100%',
                    minHeight: 208,
                    p: 2.5,
                    border: '2px solid #9b9b9b',
                    borderRadius: '20px',
                  }}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      boxSizing: 'border-box',
                      right: '-3px',
                      top: '-3px',
                      width: 'calc(40% + 18px)',
                      height: 'calc(47% + 18px)',
                      borderRight: '4px solid #f0f2f9',
                      borderTop: '4px solid #f0f2f9',
                      borderTopRightRadius: '21px',
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      boxSizing: 'border-box',
                      right: '-3px',
                      top: '-3px',
                      width: '40%',
                      height: '47%',
                      borderRight: '4px solid var(--bs-primary)',
                      borderTop: '4px solid var(--bs-primary)',
                      borderTopRightRadius: '21px',
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '-6px',
                      right: 'calc(40% + 13px)',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: '#9b9b9b',
                      zIndex: 1,
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      right: '-6px',
                      top: 'calc(47% + 13px)',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: '#9b9b9b',
                      zIndex: 1,
                    }}
                  />
                  <Paper
                    elevation={0}
                    sx={{
                      position: 'relative',
                      height: '100%',
                      boxSizing: 'border-box',
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      px: { xs: 2.5, md: 2.5 },
                      py: 4,
                      textAlign: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 24, md: 20, sm: 20, xs: 20 },
                        fontWeight: 600,
                        my: 1,
                      }}
                    >
                      Schedule M-2
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { xs: 13, md: 14 },
                        lineHeight: 1.6,
                      }}
                    >
                      Analysis of Unappropriated Retained Earnings per Books
                    </Typography>
                  </Paper>
                </Box>
              </Grid>
            </Grid>
          </Container>
          <Alert severity="warning" icon={false} sx={{ mb: 0, mt: 5 }}>
            <b>Note:</b> Additional forms may be required depending on the
            corporation's activities.
          </Alert>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Stack
                spacing={2}
                direction={{ xs: 'column-reverse', md: 'row' }}
                sx={{
                  p: 4,
                  borderRadius: 4,
                  border: 'none',
                  backgroundColor: '#f0f2f9',
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    width: { xs: '100%', md: '70%' },
                  }}
                >
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 3,
                      textAlign: 'left',
                    }}
                  >
                    Special Pricing for CPAs & Tax Professionals
                  </Typography>

                  <Typography variant="body1">
                    Filing{' '}
                    <strong style={{ fontWeight: 600 }}>
                      Form 1120 for multiple C corporations?
                    </strong>{' '}
                    We offer{' '}
                    <strong style={{ fontWeight: 600 }}>
                      exclusive bulk discounts, flexible pricing, and dedicated
                      support
                    </strong>
                    .
                  </Typography>

                  <Box component="ul" sx={{ mb: 1, '& li': { mb: 1.2 } }}>
                    <li>
                      <strong style={{ fontWeight: 600 }}>
                        More filings = Bigger discounts
                      </strong>
                    </li>
                    <li>
                      <strong style={{ fontWeight: 600 }}>
                        Save time with reusable business profiles
                      </strong>
                    </li>
                    <li>
                      <strong style={{ fontWeight: 600 }}>
                        Get dedicated support during tax season
                      </strong>
                    </li>
                  </Box>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Unlock your{' '}
                    <strong style={{ fontWeight: 600 }}>
                      custom CPA pricing
                    </strong>{' '}
                    and make this tax season easier and more efficient.
                  </Typography>
                </Box>

                <Box
                  component="div"
                  sx={{
                    width: { xs: '100%', md: '40%' },
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    my: { xs: 3, md: 0 },
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      mt: { xs: 0, md: 4 },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        transform: 'scale(1.1)',
                      },
                    }}
                    className="btn-primary"
                    href="/contact-us/"
                  >
                    Contact Us Now
                  </Button>
                </Box>
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid size={{ md: 6, xs: 12 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/common-form-1120-use.webp" />
                  <source srcSet="/assets/images/common-form-1120-use.png" />
                  <img
                    src="/assets/images/common-form-1120-use.png"
                    alt="Common Form 1120 Use Cases"
                    className="img-responsive"
                    loading="lazy"

                    width={586}
                    height={306}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,
                    textAlign: 'left',
                  }}
                >
                  Common Form 1120 Use Cases
                </Typography>
                <Box component="ul" sx={{ mb: 1, '& li': { mb: 1.2 } }}>
                  <li>
                    Filing an annual federal income tax return for a{' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      C corporation{' '}
                    </strong>{' '}
                  </li>
                  <li>
                    Filing a corporate tax return for a{' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      newly formed corporation{' '}
                    </strong>{' '}
                  </li>
                  <li>
                    Filing Form 1120 for an{' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      LLC that has elected to be taxed as a C corporation{' '}
                    </strong>{' '}
                  </li>
                  <li>
                    Preparing accurate IRS Form 1120 filings{' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      for clients with multiple C corporations{' '}
                    </strong>{' '}
                  </li>
                  <li>
                    Filing{' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      short-year or fiscal-year{' '}
                    </strong>{' '}
                    corporate tax returns{' '}
                  </li>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,
                    textAlign: 'left',
                  }}
                >
                  Common Form 1120 Mistakes to Avoid{' '}
                </Typography>

                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    {' '}
                    Failing to{' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      reconcile the balance sheet{' '}
                    </strong>{' '}
                    with the corporation’s books and records.{' '}
                  </li>
                  <li>
                    Misreporting{' '}
                    <strong style={{ fontWeight: 600 }}>
                      shareholder information or ownership
                    </strong>{' '}
                    details.{' '}
                  </li>
                  <li>
                    Missing{' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      required schedules or attachments{' '}
                    </strong>{' '}
                    with the corporate return.
                  </li>
                  <li>
                    Using{' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      incorrect amounts or codes{' '}
                    </strong>{' '}
                    on supporting schedules and forms.
                  </li>
                  <li>
                    {' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      Filing the return late or failing{' '}
                    </strong>{' '}
                    to make required tax payments on time.
                  </li>
                </Box>
                <Alert severity="info" id="whatare" icon={false} sx={{ mb: 1 }}>
                  <b>Tips:</b> TaxZerone helps identify common errors before you
                  submit.
                </Alert>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  position: 'relative',
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '60%',
                  maxWidth: { xs: 280, sm: 340, md: 480 },
                  mx: 'auto',
                  my: { xs: 0, md: 0 },
                  px: { xs: 2, sm: 0 },
                }}
              >
                <Box
                  component="img"
                  src="/assets/images/why-compare-form-941-e-file-software-img.webp"
                  alt="Common Form 1120 Mistakes to Avoid"
                  sx={{
                    width: '85%',
                    height: 'auto',
                    display: 'block',
                    position: 'relative',
                    zIndex: 1,
                  }}
                />

                {/* C Corporation */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: { xs: '0%', sm: '10%', md: '10%' },
                    left: { xs: '-12%', sm: '-5%', md: '3%' },
                    bgcolor: '#FBE4E0',
                    color: '#0F172A',
                    fontSize: { xs: 10, sm: 12, md: 14 },
                    fontWeight: 600,
                    px: { xs: 1.5, sm: 2, md: 2.5 },
                    py: { xs: 0.8, sm: 1.2, md: 1.5 },
                    borderRadius: 2,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                    zIndex: 2,
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                    opacity: 0.85,
                  }}
                >
                  Balance Reconciliation
                </Box>

                {/* New Corporation */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: { xs: '35%', sm: '38%', md: '42%' },
                    left: { xs: '68%', sm: '70%', md: '72%' },
                    bgcolor: '#F7D9CE',
                    color: '#0F172A',
                    fontSize: { xs: 10, sm: 12, md: 14 },
                    fontWeight: 600,
                    px: { xs: 1.5, sm: 2, md: 2.5 },
                    py: { xs: 0.8, sm: 1.2, md: 1.5 },
                    borderRadius: 2,
                    textAlign: 'center',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                    zIndex: 2,
                    whiteSpace: 'nowrap',
                    opacity: 0.85,
                  }}
                >
                  Ownership Reporting
                </Box>

                {/* LLC as C Corp */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: { xs: '58%', sm: '54%', md: '50%' },
                    left: { xs: '-12%', sm: '-8%', md: '2%' },
                    bgcolor: '#E3DEF7',
                    color: '#0F172A',
                    fontSize: { xs: 10, sm: 12, md: 14 },
                    fontWeight: 600,
                    px: { xs: 1.5, sm: 2, md: 2.5 },
                    py: { xs: 0.8, sm: 1.2, md: 1.5 },
                    borderRadius: 2,
                    textAlign: 'center',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                    zIndex: 2,
                    whiteSpace: 'nowrap',
                    opacity: 0.85,
                  }}
                >
                  Missing Schedules
                </Box>

                {/* Multiple C Corps */}
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: { xs: '5%', sm: '8%', md: '12%' },
                    left: { xs: '0%', sm: '8%', md: '12%' },
                    bgcolor: '#F6D9E8',
                    color: '#0F172A',
                    fontSize: { xs: 10, sm: 12, md: 14 },
                    fontWeight: 600,
                    px: { xs: 1.5, sm: 2, md: 2.5 },
                    py: { xs: 0.8, sm: 1.2, md: 1.5 },
                    borderRadius: 2,
                    textAlign: 'center',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                    zIndex: 2,
                    whiteSpace: 'nowrap',
                    opacity: 0.85,
                  }}
                >
                  Incorrect Codes
                </Box>

                {/* Short-Year Return */}
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: { xs: '18%', sm: '18%', md: '20%' },
                    left: { xs: '70%', sm: '78%', md: '80%' },
                    bgcolor: '#E0F2FE',
                    color: '#0F172A',
                    fontSize: { xs: 10, sm: 12, md: 14 },
                    fontWeight: 600,
                    px: { xs: 1.5, sm: 2, md: 2.5 },
                    py: { xs: 0.8, sm: 1.2, md: 1.5 },
                    borderRadius: 2,
                    textAlign: 'center',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                    zIndex: 2,
                    whiteSpace: 'nowrap',
                    opacity: 0.85,
                  }}
                >
                  Late Filing
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        component="section"
        sx={{ bgcolor: '#f0f2f9', py: { xs: 6, md: 8 } }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              background: `radial-gradient(ellipse 70% 100% at 50% 10%, #213e99 0%, rgba(33, 62, 153, 0.6) 35%, rgba(33, 62, 153, 0) 75%),#060918`,
              border: '1px solid #dceee4',
              borderRadius: '24px',
              p: { xs: 4, md: 6 },
              textAlign: 'center',
              boxShadow: '0 15px 40px rgba(0,0,0,0.05)',
              color: '#fff',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 32, md: 28, sm: 24, xs: 20 },
                fontWeight: 700,
                mb: 2,
              }}
            >
              Ready to File Form 1120 Online?
            </Typography>

            <Typography
              variant="body1"
              sx={{
                mb: 1,
                fontSize: { xs: 13, sm: 16 },
                lineHeight: 1.8,
                maxWidth: 700,
                mx: 'auto',
                fontWeight: 600,
              }}
            >
              Prepare and e-file your corporate tax return with TaxZerone.
            </Typography>
            <Typography
              variant="body2"
              sx={{
                mb: 4,
                fontSize: { xs: 13, sm: 16 },
                lineHeight: 1.8,
                maxWidth: 700,
                mx: 'auto',
              }}
            >
              File your{' '}
              <strong style={{ fontWeight: 600 }}>Form 1120 tax return</strong>{' '}
              securely with guided filing, built-in validation, and a simple
              online filing process.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 4,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &active': {
                    backgroundColor: '#fff !important',
                    color: '#444',
                    transform: 'scale(1.1)',
                  },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1120`}
              >
                E-File Now
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>
      <Container
        maxWidth="lg"
        component="section"
        aria-labelledby="form1120-faqs"
      >
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              id="form1120-faqs"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What is Schedule J on Form 1120?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      {' '}
                      <strong style={{ fontWeight: 600 }}>
                        Schedule J on Form 1120 is used to calculate the
                        corporation’s income tax liability and reconcile tax
                        payments and credits
                      </strong>
                      . It includes the corporation’s income tax calculation and
                      applicable credits, payments, and other amounts that
                      affect the tax due or overpayment.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Does Form 1120 report dividends?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Yes. Dividends and certain related items may be reported
                      on Form 1120, including through Schedule C when
                      applicable. The tax treatment depends on the type of
                      dividend and applicable deduction rules.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What is the difference between IRS Form 1120 and 1120-S?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text" sx={{ mt: 1 }}>
                    IRS Form 1120 is generally filed by C corporations, while
                    Form 1120-S is filed by S corporations. An S corporation
                    generally passes profits and losses through to its
                    shareholders, who report them on their individual tax
                    returns, helping avoid double taxation. A corporation that
                    does not qualify for S corporation status generally files
                    Form 1120 as a C corporation.
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Does Form 1120 include Schedule K-1?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      No. Form 1120 does not generally include shareholder
                      Schedule K-1s. Schedule K-1 is associated with
                      pass-through returns such as Form 1065 and Form
                      1120-S.{' '}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What happens if Form 1120 is filed late?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text" sx={{ mt: 1 }}>
                    If Form 1120 is filed late, the corporation may owe a{' '}
                    <strong style={{ fontWeight: 600 }}>
                      late-filing penalty and interest. The IRS generally
                      charges 5% of the unpaid tax for each month or part of a
                      month the return is late, up to 25%
                    </strong>
                    . A reasonable-cause exception may apply if the corporation
                    can show that it had a valid reason for filing late.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form1120;
